import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.map.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.weak-map.js';
import 'core-js/modules/web.dom-collections.iterator.js';

function memoize(fn) {
  var primitiveCache = new Map();
  var objectCache = new WeakMap();
  return function memoized(arg) {
    var key = arg !== null && arg !== void 0 ? arg : '__singleValue__';
    var cache = key instanceof Object ? objectCache : primitiveCache;
    var cached = cache.get(key);
    if (cached != null) {
      return cached;
    }
    var value = fn(arg);
    cache.set(key, value);
    return value;
  };
}

export { memoize as default };
